import { css } from '@emotion/core'

import { palette, typography } from 'main/ui'

export const lightboxStyles = css`
  .ril-caption-content {
    color: ${palette.white};
    font-family: ${typography.fontFamily.ui};
    font-size: ${typography.fontSize.text};
    font-weight: ${typography.fontWeight.regular};
    margin: 0 auto;
  }
`
